import {
  Component,
  ViewEncapsulation,
  AfterViewInit,
  OnInit,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";

import { Events } from "@service/events.service";
import { ProjectService } from "@service/project.service";

import * as is from "is";

const STATUS_BTN = [
  { className: "btn-define", value: "Definido" },
  { className: "btn-review", value: "Revisar" },
  { className: "btn-discard", value: "Descartado" },
  { className: "btn-unvalued", value: "Não avaliado" },
];

const CARDS = [
  {
    title: "Estudante Planeja o Projeto",
    className: "order-first",
    icon: "fa-user-check",
    checkboxes: [
      { name: "deadline", label: "Cronograma", status: "" },
      { name: "search_strategy", label: "Estratégia de Busca", status: "" },
      { name: "search_string", label: "String Base", status: "" },
      { name: "sources", label: "Fontes", status: "" },
      { name: "keywords", label: "Palavras-Chaves", status: "" },
      { name: "research_questions", label: "Questões de Pesquisa", status: "" },
      { name: "objectives", label: "Objetivos", status: "" },
      { name: "justification", label: "Justificativa", status: "" },
      { name: "hypothesis", label: "Hipóteses", status: "" },
      { name: "selection_criteria", label: "Critérios de Seleção", status: "" },
      { name: "questions", label: "Avaliação Metodológica", status: "" },
      { name: "answers", label: "Respostas", status: "" },
      { name: "punctuation", label: "Pontuação", status: "" },
      { name: "questions_form", label: "Extração de Dados", status: "" },
    ],
  },
  {
    title: "Estudante Desenvolve o Projeto",
    className: "",
    icon: "fa-clipboard-list",
    checkboxes: [
      { name: "research", label: "Pesquisa", status: "" },
      { name: "import_studies", label: "Importar Estudos", status: "" },
      { name: "select_studies", label: "Selecionar Estudos", status: "" },
      { name: "annotations", label: "Fichamento", status: "" },
    ],
  },
  {
    title: "Estudante Escreve o Projeto",
    className: "order-last",
    icon: "fa-pencil-alt",
    checkboxes: [{ name: "writing", label: "Escrita", status: "" }],
  },
];

@Component({
  selector: "app-overview",
  templateUrl: "./overview.component.html",
  styleUrls: ["./overview.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class OverviewComponent implements OnInit, AfterViewInit {
  btns_status = STATUS_BTN;
  cards = CARDS;
  progress = [0, 0, 0];

  constructor(
    private ar: ActivatedRoute,
    private router: Router,
    private toast: ToastrService,
    private projectService: ProjectService,
    private events: Events
  ) {
    this.events.setPlaylistUrl("PLjqmpybbUA6uWTV9B3tOXLgt89y0dfvq9");
  }

  ngOnInit() {}

  ngAfterViewInit() {
    // this.progress = [...this.progress];
    const id = this.ar.snapshot.paramMap.get("id");

    if (is.null(id)) {
      this.toast.error(
        "O projeto informado não foi encontrado, tente novamente!"
      );
      this.router.navigate(["/"]);
    } else {
      this.projectService.getCycles(+id).subscribe((cycles) => {
        this.progress[0] = this.projectService.calcPercentage({ 1: cycles[1] });
        this.progress[1] = this.projectService.calcPercentage({ 2: cycles[2] });
        this.progress[2] = this.projectService.calcPercentage({ 3: cycles[3] });
        for (const i in cycles) {
          const checkboxesByCycle = this.cards[+i - 1].checkboxes;
          for (const checkboxName in cycles[i]) {
            const indexCheckboxesByCycle = checkboxesByCycle
              .map((item) => item.name)
              .indexOf(checkboxName);
            if (indexCheckboxesByCycle > -1) {
              checkboxesByCycle[indexCheckboxesByCycle].status =
                cycles[i][checkboxName].status;
            }
          }
        }
      });
    }
  }
}
